import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "network",
  class: "mb-8"
}

import { Label } from '@/popup/components/shared/Form/Form'
import Network from '@/popup/components/views/Home/Settings/Network/Network/Network.vue'
import Relayer from '@/popup/components/views/Home/Settings/Network/Relayer/Relayer.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Network',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Label), {
      "extra-class": "is-title mb-2",
      label: _ctx.$t('settings.network.title')
    }, null, 8 /* PROPS */, ["label"]),
    _createVNode(Network, { from: "settings" }),
    _createVNode(Relayer)
  ]))
}
}

})